
import { defineComponent, PropType } from 'vue'
import { AgentMemory } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'
import { getDefaultAvatar } from '~/utils/ui'
import { getAgentKindIcon, getAgentKindName } from '~/utils/agents'

export default defineComponent({
  name: 'MemoryCard',
  props: {
    memory: {
      type: Object as PropType<AgentMemory>,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getDefaultAvatar,
    getAgentKindIcon,
    getAgentKindName
  },
  computed: {
    formatMemoryDate() {
      return formatDate(parseISODate(this.memory.createdAt), 'lll')
    }
  }
})
